@layer module {
.nav-support {
            display: inline-flex;
            align-items: center;
    }

.nav-unread-dot {
            flex-shrink: 0;
    }

.header-wrapper {
            grid-area: header;
            border-bottom: 1px solid;
            z-index: 99;
    }

.header-wrapper .overlay {
            z-index: 10;
            position: absolute;
            visibility: hidden;
            pointer-events: none;
    }

.overlay.opened {
            visibility: visible;
            pointer-events: auto;
    }

.header-wrapper a {
            white-space: nowrap;
            text-decoration: none;
    }

.header-wrapper a:global(.disabled) {
            pointer-events: none;
    }

.header-container {
            display: flex;
            align-items: center;
            justify-content: space-between;
    }

.header-content {
            display: flex;
            flex: 1 1 auto;
            align-items: center;
            overflow-x: auto;
    }

.header-content a {
            display: flex;
            flex-shrink: 0;
            align-items: center;
    }

.header-inner {
            display: flex;
            flex-shrink: 0;
            align-items: center;
    }

.hamburger-menu a {
            display: flex;
            align-items: center;
    }

.hamburger-icon {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            position: relative;
            z-index: 10;
            border: none;
            cursor: pointer;
    }

.hamburger-icon:focus {
            outline: none;
    }

.hamburger-icon.opened {
            z-index: 10001;
    }

.hamburger-icon > span {
            position: relative;
            display: block;
    }

.hamburger-icon > span::before,
.hamburger-icon > span::after {
            content: '';
            position: absolute;
    }

.hamburger-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            z-index: 10000;
            transform: translateX(100%);
            visibility: hidden;
    }

.hamburger-content.opened {
            transform: translateX(0);
            visibility: visible;
    }

.hamburger-content a {
            text-decoration: none;
    }

      @media (max-width: 1150px) {
                .hamburger-content {
                        align-items: flex-start;
                        justify-content: start;
                    }

                .hamburger-content a {
                        text-align: left;
                    }
          }
} // layer module










@layer app {
.brand-logo-img {
            max-height: $size-28;
    }

.nav-support {
            gap: $size-4;
    }

.nav-unread-dot {
            width: $size-6;
            height: $size-6;
            border-radius: 50%;
            margin-bottom: $size-6;
    }

.header-wrapper {
            margin: 0;
            padding: 0;
            width: 100%;
    }

.header-wrapper .overlay {
            width: 100vw;
            height: 100vh;
            top: 0;
            left: 0;
    }

.header-container {
            gap: $size-28;
            width: 100%;
            height: 100%;
            padding: 0 $size-24;
    }

.header-content {
            gap: $size-4;
            min-width: 0;
    }

.header-content a {
            padding: $size-8 $size-14;
            border-radius: $size-20;
    }

.header-inner {
            height: 100%;
            gap: $size-10;
    }

.hamburger-menu {
            padding-right: $size-10;
    }

.hamburger-menu a {
            margin-bottom: 0;
            padding: $size-16 $size-25;
    }

.hamburger-icon {
            padding: 0;
    }

.hamburger-icon > span {
            width: $size-25;
            height: $size-25;
    }

.hamburger-icon > span::before,
.hamburger-icon > span::after {
            left: 0;
            width: 100%;
            height: $size-3;
            border-radius: $size-1-5;
    }

.hamburger-icon > span::before {
            top: calc(50% - $size-10-5);
    }

.hamburger-icon > span::after {
            top: calc(50% + $size-7-5);
    }

.hamburger-content {
            top: 0;
            right: 0;
            padding: $size-30;
            min-width: $size-220;
            height: 100vh;
    }

      @media (min-width: 320px) {
                .hamburger-menu {
                        padding-right: $size-15;
                    }
          }

      @media (max-width: 1150px) {
                .hamburger-content {
                        padding: $size-36 $size-20 $size-20;
                    }
                .hamburger-content a {
                        padding: 0;
                        height: $size-60;
                    }
          }

      @media (max-width: 515px) {
                .hamburger-content {
                        height: 100vh;
                    }
          }

.hamburger-icon {
            background: transparent;
    }

.hamburger-icon > span {
            background: linear-gradient(var(--header-icon-muted), var(--header-icon-muted)) center / 100% $size-3 no-repeat;
            transition: background-size 0.3s ease;
    }

.hamburger-icon > span::before,
.hamburger-icon > span::after {
            background: var(--header-icon-muted);
            transition: transform 0.3s ease;
    }

.hamburger-icon.opened > span {
            background-size: 0 $size-3;
    }

.hamburger-icon.opened > span::before {
            transform: translateY($size-9) rotate(45deg);
    }

.hamburger-icon.opened > span::after {
            transform: translateY($size-neg-9) rotate(-45deg);
    }

.nav-unread-dot {
            background: var(--support-error-text);
    }

.header-wrapper {
            background: var(--bg-surface);
            border-bottom-color: var(--border-default);
            color: var(--text-primary);
            font-size: var(--font-size-base);
            font-style: normal;
            font-weight: normal;
            line-height: $size-17;
    }

.header-wrapper .overlay {
            background: var(--banky-black--50);
            opacity: 0;
            transition: opacity 0.3s ease, visibility 0s linear 0.3s;
    }

.overlay.opened {
            opacity: 1;
            transition: opacity 0.3s ease, visibility 0s;
    }

.header-content a {
            color: var(--text-body);
            transition: background-color 0.15s ease;
    }

.header-content a:hover {
            background: var(--bg-neutral-chip);
    }

.header-content a:global(.active-tab) {
            background: var(--color-brand);
            color: var(--color-on-brand);
            font-weight: 500;
    }

.hamburger-menu div:global(.title) {
            color: var(--text-primary);
    }

.hamburger-content {
            box-shadow: var(--shadow-header-action);
            color: var(--text-primary);
            font-size: var(--font-size-base);
            font-style: normal;
            font-weight: normal;
            line-height: $size-17;
            background: var(--banky-white);
            transition: transform 0.3s ease, visibility 0s linear 0.3s;
    }

.hamburger-content.opened {
            transition: transform 0.3s ease, visibility 0s;
    }

.hamburger-icon svg:hover > * {
            fill: var(--header-icon-muted);
    }

.hamburger-content a, .hamburger-content div:global(.title) {
            color: var(--text-primary);
            font-size: var(--font-size-base);
            font-style: normal;
            font-weight: normal;
            line-height: $size-17;
    }

.hamburger-content a:global(.active-tab) {
            color: var(--text-primary);
            font-weight: normal;
            border-bottom: none;
    }

      @media (max-width: 1150px) {
                .hamburger-content a {
                        font-size: var(--font-size-lg);
                        line-height: $size-19;
                    }
          }

      @media (prefers-reduced-motion: reduce) {
                .hamburger-content,
                .hamburger-content.opened,
                .header-wrapper .overlay,
                .overlay.opened,
                .hamburger-icon > span,
                .hamburger-icon > span::before,
                .hamburger-icon > span::after {
                        transition: none;
                    }
          }
} // layer app
